Pixlee.module('SlideShowApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView, headerView;
            var _this = this;
            var layout = this.getLayout();
            var onShowLayout = function() {
                var showLightbox;
                if (_.isFalsy(App.displayOptions.get('widget_lightbox_showHide'))) {
                    showLightbox = false;
                } else {
                    showLightbox = true;
                }

                var photoscollection = App.request('get:photos:widget:photowall');
                collectionView = _this.getCollectionView({
                    collection: photoscollection,
                    showLightbox: showLightbox
                });
                photoscollection.on('sync', function(collection, resp) {
                    gon.sortType = resp.sortType;
                    if (!_.isFalsy(collectionView.sly)) {
                        App.commands.execute('opened:slideshow', collectionView.sly.rel, photoscollection);
                    }
                });
                _this.show(collectionView, {
                    region: layout.frame
                });

            };
            this.listenTo(layout, 'show', onShowLayout);

            App.commands.setHandler('stylesheet:generated', function(css, params, displayOptions) {
                App.displayOptions.set('widget_autoplay_showHide', params.widget_autoplay_showHide);
                App.displayOptions.set('slideshow_size_input', params.slideshow_size_input);
                App.displayOptions.set('widget_lightbox_showHide', params.widget_lightbox_showHide);
                if (!_.isFalsy(params.widget_lightbox_interval)) {
                    App.displayOptions.set('widget_lightbox_interval', params.widget_lightbox_interval);
                }
                if (params.slideshow_size_input != "640") {
                    collectionView.triggerMethod('reload:sly');
                }
                if (_.isFalsy(params.widget_autoplay_showHide)) {
                    collectionView.triggerMethod('stop:slideshow');
                } else {
                    collectionView.triggerMethod('start:slideshow');
                }

                onShowLayout();
            });
            this.show(layout, {
                loading: true
            });
        },
        getLayout: function(options) {
            return new Show.Layout(options);
        },
        getCollectionView: function(options) {
            return new Show.SlideShowCollection(options);
        }
    });

});